<template>
  <DxPopup @hidden="onHidden" :visible="showChargerListPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="auto" width="768" container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12">
                <DxDataGrid
                  :ref="chargerRef"
                  :data-source="chargerList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                >
                  <DxPager :show-page-size-selector="false"/>
                  <DxPaging :page-size="20" />
                  <DxColumn data-field="enm" caption="Name(English)" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="vnmAbb" caption="Name(Vietnamese)" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="posNm" caption="Position" alignment="left" :allow-editing="false" width="10%" />
                  <DxColumn data-field="officeTel" caption="Tel" alignment="center" :allow-editing="false" width="10%" />
                  <DxColumn data-field="email" caption="e-Mail" alignment="left" :allow-editing="false"
                                        cell-template="emailCellTmpl" />
                  <template #emailCellTmpl="{ data: cellInfo }">
                    <a :href="`mailto:${cellInfo.value}`">{{ cellInfo.value }}</a>
                  </template>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import BaseDataGrid from '@/components/base/BaseDataGrid'
import { DxPopup } from 'devextreme-vue/popup'
import { getBuyerList } from '@/api/view/hycot/Z/home0000'

export default {
  name: 'chargerListPop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup
  },
  props: {
    showChargerListPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'Charger Information',
       chargerRef: 'chargerRef',
       chargerList: [],
     }
  },
  computed: {
    noticeInstance() {
      return this.GetDataGrid(this.chargerRef)
    }
  },
  watch: {
    'showChargerListPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.noticeInstance.option('defaultPaging', false)

      this.retrieve()
    },
    clearData() {
      this.chargerList = []
      this.selectedNotice = {}
      this.noticeInstance.clearSelection()
    },
    async retrieve() {
      this.openLoading()
      this.clearData()
      
      await getBuyerList().then(res => {
        // console.log('res', res)

        this.chargerList = res.list
      }).finally(() => {
        this.endLoading()
      })
    },
    onHidden(e) {
      this.$emit('update:showChargerListPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>